import { Controller } from 'stimulus'

function toggleIsCompany() {
  const isCompanyCheckbox = document.querySelector('.js-is-company-checkbox');
  const isCompanySection = document.querySelector('.js-is-company-section');
  if (!isCompanyCheckbox) {
    return;
  }
  isCompanyCheckbox.addEventListener('change', function() {
    if (this.checked) {
      isCompanySection.classList.remove('hidden');
      document.getElementById('vat_code').required = true;
      document.getElementById('company_name').required = true;
      document.getElementById('sdi').required = true;
    } else {
      isCompanySection.classList.add('hidden');
      document.getElementById('vat_code').required = false;
      document.getElementById('company_name').required = false;
      document.getElementById('sdi').required = false;
    }
  });
}

export default class FormController extends Controller {
  static targets = ['feedback']

  connect() {
    toggleIsCompany();
    this.element.addEventListener('submit', (e) => {
      e.preventDefault()
      this.onSubmit()
    })
  }

  onSubmit = () => {
    const formData = new FormData(this.element)

    fetch(this.element.getAttribute('action'), { method: this.element.method || 'POST', body: formData })
      .then((response) => response.json())
      .then((responseJson) => {
        console.log(responseJson)

        if (this.hasFeedbackTarget) {
          if (responseJson.result) {
            this.feedbackTarget.innerHTML = document.querySelector('meta[name="form-submit-success"]').content || "Message sent successfully!"
            this.feedbackTarget.classList.add('js-feedback-success')
          } else {
            this.feedbackTarget.innerHTML = responseJson.error || document.querySelector('meta[name="form-submit-error"]').content || "An error occurred while sending the message. Please try again later."
            this.feedbackTarget.classList.add('js-feedback-error')
          }
        }

        this.element.reset()
      })
      .catch((err) => {
        console.log(err)

        if (this.hasFeedbackTarget) {
          this.feedbackTarget.innerHTML = document.querySelector('meta[name="form-submit-error"]').content || "An error occurred while sending the message. Please try again later."
          this.feedbackTarget.classList.add('js-feedback-error')
        }
      })
  }
}